/* eslint-disable import/namespace */
/* eslint-disable import/no-unresolved */
import "../../assets/style/admin/style.css";
import "../../assets/style/admin/all.min.css";
import React, { useState } from "react";
import BusinessView from "../../components/admin/business";
//import { InitialData } from "../../slices/InitialDataSlice";
import { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {useParams} from "react-router-dom"
import {BusinessProgressBar} from "../../components/admin/BusinessProgressBar"

export function AddBusiness() {
  let { pageView } = useParams();
  const dispatch = useDispatch();
  const initialData =  useSelector(state => state.initialData.CommonData)
  const [constitutions, setConstitutions] = useState([]);
  const [state, setState] = useState([]);
  
  useEffect(()=>{
    //dispatch(InitialData()); 
  },[dispatch])

  useMemo(()=>{
    if(typeof initialData.constitutions !== "undefined"){
      setConstitutions(initialData.constitutions.map( (item) =>(  {value:item.id, label:item.title} )))
    }

    if(typeof initialData.states !== "undefined"){
      setState(initialData.states.map( (item) =>(  {value:item.id, label:item.name} )))
    }
  },[initialData]);  
  let ViewName = BusinessView[pageView];
  const pageIndex = Object.keys(BusinessView).indexOf(pageView)+1
  return (
    <React.Fragment>
      <div className="row">
        <BusinessProgressBar page={pageView} pageIndex={pageIndex}/>
        
        {typeof ViewName !== "undefined"?(<ViewName gstRegistrationTypes={initialData.gstRegistrationTypes}  businessNature={initialData.businessEntityNatures} countryZone={state} constitutions={constitutions}  />):<div className="col-12"> View Not Found </div>}          
        {/* <div className="col-12 mb-3 text-right">
              {page !== 1 && (
                <button
                  type="button"
                  className="btn btn-primary btn-lg px-5 m-3"
                  onClick={goPrevPage}
                >
                  Prev
                </button>
              )}
              {page !== 4 && (
                <button
                  type="button"
                  className="btn btn-success btn-lg px-5"
                  onClick={handleSubmit(goNextPage)}
                >
                  Next
                </button>
              )}
              {page === 4 && 
              <button
                  type="submit"
                  className="btn btn-success btn-lg px-5"
                >
                  Submit
                </button>
              }
            </div> */}
        
      </div>
    </React.Fragment>
  );

  // console.log(page)
  // return (
  //  <div className="ecommarce-dashboard">
  //    <BusinessForm />
  //  </div>
    
  // )
}
